export default "__VITE_ASSET__DhIvlVgl__"